/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SigninImport } from './routes/signin'
import { Route as AuthCallbackImport } from './routes/auth-callback'
import { Route as LayoutImport } from './routes/_layout'
import { Route as IndexImport } from './routes/index'
import { Route as LayoutSetPasswordImport } from './routes/_layout/set-password'
import { Route as LayoutForgetPasswordImport } from './routes/_layout/forget-password'
import { Route as LayoutAuthImport } from './routes/_layout/_auth'
import { Route as LayoutAuthProfileIndexImport } from './routes/_layout/_auth/profile/index'
import { Route as LayoutAuthCompetitionsIndexImport } from './routes/_layout/_auth/competitions/index'
import { Route as LayoutAuthProfileChangePasswordImport } from './routes/_layout/_auth/profile/change-password'
import { Route as LayoutAuthProfileUserIdImport } from './routes/_layout/_auth/profile/$userId'
import { Route as LayoutAuthCompetitionsLicenseIdImport } from './routes/_layout/_auth/competitions/$licenseId'
import { Route as LayoutAuthCompetitionsLicenseIdSubmissionImport } from './routes/_layout/_auth/competitions/$licenseId/submission'
import { Route as LayoutAuthCompetitionsLicenseIdScoreImport } from './routes/_layout/_auth/competitions/$licenseId/score'
import { Route as LayoutAuthCompetitionsLicenseIdInfoImport } from './routes/_layout/_auth/competitions/$licenseId/info'
import { Route as LayoutAuthCompetitionsLicenseIdDataImport } from './routes/_layout/_auth/competitions/$licenseId/data'

// Create Virtual Routes

const AboutLazyImport = createFileRoute('/about')()
const LayoutSignoutLazyImport = createFileRoute('/_layout/signout')()
const LayoutSigninEmailLazyImport = createFileRoute('/_layout/signin-email')()

// Create/Update Routes

const AboutLazyRoute = AboutLazyImport.update({
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const SigninRoute = SigninImport.update({
  path: '/signin',
  getParentRoute: () => rootRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  path: '/auth-callback',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LayoutSignoutLazyRoute = LayoutSignoutLazyImport.update({
  path: '/signout',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/signout.lazy').then((d) => d.Route),
)

const LayoutSigninEmailLazyRoute = LayoutSigninEmailLazyImport.update({
  path: '/signin-email',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/signin-email.lazy').then((d) => d.Route),
)

const LayoutSetPasswordRoute = LayoutSetPasswordImport.update({
  path: '/set-password',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutForgetPasswordRoute = LayoutForgetPasswordImport.update({
  path: '/forget-password',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAuthRoute = LayoutAuthImport.update({
  id: '/_auth',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAuthProfileIndexRoute = LayoutAuthProfileIndexImport.update({
  path: '/profile/',
  getParentRoute: () => LayoutAuthRoute,
} as any)

const LayoutAuthCompetitionsIndexRoute =
  LayoutAuthCompetitionsIndexImport.update({
    path: '/competitions/',
    getParentRoute: () => LayoutAuthRoute,
  } as any)

const LayoutAuthProfileChangePasswordRoute =
  LayoutAuthProfileChangePasswordImport.update({
    path: '/profile/change-password',
    getParentRoute: () => LayoutAuthRoute,
  } as any)

const LayoutAuthProfileUserIdRoute = LayoutAuthProfileUserIdImport.update({
  path: '/profile/$userId',
  getParentRoute: () => LayoutAuthRoute,
} as any)

const LayoutAuthCompetitionsLicenseIdRoute =
  LayoutAuthCompetitionsLicenseIdImport.update({
    path: '/competitions/$licenseId',
    getParentRoute: () => LayoutAuthRoute,
  } as any)

const LayoutAuthCompetitionsLicenseIdSubmissionRoute =
  LayoutAuthCompetitionsLicenseIdSubmissionImport.update({
    path: '/submission',
    getParentRoute: () => LayoutAuthCompetitionsLicenseIdRoute,
  } as any)

const LayoutAuthCompetitionsLicenseIdScoreRoute =
  LayoutAuthCompetitionsLicenseIdScoreImport.update({
    path: '/score',
    getParentRoute: () => LayoutAuthCompetitionsLicenseIdRoute,
  } as any)

const LayoutAuthCompetitionsLicenseIdInfoRoute =
  LayoutAuthCompetitionsLicenseIdInfoImport.update({
    path: '/info',
    getParentRoute: () => LayoutAuthCompetitionsLicenseIdRoute,
  } as any)

const LayoutAuthCompetitionsLicenseIdDataRoute =
  LayoutAuthCompetitionsLicenseIdDataImport.update({
    path: '/data',
    getParentRoute: () => LayoutAuthCompetitionsLicenseIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/auth-callback': {
      id: '/auth-callback'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/_layout/_auth': {
      id: '/_layout/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutAuthImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/forget-password': {
      id: '/_layout/forget-password'
      path: '/forget-password'
      fullPath: '/forget-password'
      preLoaderRoute: typeof LayoutForgetPasswordImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/set-password': {
      id: '/_layout/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof LayoutSetPasswordImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/signin-email': {
      id: '/_layout/signin-email'
      path: '/signin-email'
      fullPath: '/signin-email'
      preLoaderRoute: typeof LayoutSigninEmailLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/signout': {
      id: '/_layout/signout'
      path: '/signout'
      fullPath: '/signout'
      preLoaderRoute: typeof LayoutSignoutLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/_auth/competitions/$licenseId': {
      id: '/_layout/_auth/competitions/$licenseId'
      path: '/competitions/$licenseId'
      fullPath: '/competitions/$licenseId'
      preLoaderRoute: typeof LayoutAuthCompetitionsLicenseIdImport
      parentRoute: typeof LayoutAuthImport
    }
    '/_layout/_auth/profile/$userId': {
      id: '/_layout/_auth/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/profile/$userId'
      preLoaderRoute: typeof LayoutAuthProfileUserIdImport
      parentRoute: typeof LayoutAuthImport
    }
    '/_layout/_auth/profile/change-password': {
      id: '/_layout/_auth/profile/change-password'
      path: '/profile/change-password'
      fullPath: '/profile/change-password'
      preLoaderRoute: typeof LayoutAuthProfileChangePasswordImport
      parentRoute: typeof LayoutAuthImport
    }
    '/_layout/_auth/competitions/': {
      id: '/_layout/_auth/competitions/'
      path: '/competitions'
      fullPath: '/competitions'
      preLoaderRoute: typeof LayoutAuthCompetitionsIndexImport
      parentRoute: typeof LayoutAuthImport
    }
    '/_layout/_auth/profile/': {
      id: '/_layout/_auth/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LayoutAuthProfileIndexImport
      parentRoute: typeof LayoutAuthImport
    }
    '/_layout/_auth/competitions/$licenseId/data': {
      id: '/_layout/_auth/competitions/$licenseId/data'
      path: '/data'
      fullPath: '/competitions/$licenseId/data'
      preLoaderRoute: typeof LayoutAuthCompetitionsLicenseIdDataImport
      parentRoute: typeof LayoutAuthCompetitionsLicenseIdImport
    }
    '/_layout/_auth/competitions/$licenseId/info': {
      id: '/_layout/_auth/competitions/$licenseId/info'
      path: '/info'
      fullPath: '/competitions/$licenseId/info'
      preLoaderRoute: typeof LayoutAuthCompetitionsLicenseIdInfoImport
      parentRoute: typeof LayoutAuthCompetitionsLicenseIdImport
    }
    '/_layout/_auth/competitions/$licenseId/score': {
      id: '/_layout/_auth/competitions/$licenseId/score'
      path: '/score'
      fullPath: '/competitions/$licenseId/score'
      preLoaderRoute: typeof LayoutAuthCompetitionsLicenseIdScoreImport
      parentRoute: typeof LayoutAuthCompetitionsLicenseIdImport
    }
    '/_layout/_auth/competitions/$licenseId/submission': {
      id: '/_layout/_auth/competitions/$licenseId/submission'
      path: '/submission'
      fullPath: '/competitions/$licenseId/submission'
      preLoaderRoute: typeof LayoutAuthCompetitionsLicenseIdSubmissionImport
      parentRoute: typeof LayoutAuthCompetitionsLicenseIdImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  LayoutRoute: LayoutRoute.addChildren({
    LayoutAuthRoute: LayoutAuthRoute.addChildren({
      LayoutAuthCompetitionsLicenseIdRoute:
        LayoutAuthCompetitionsLicenseIdRoute.addChildren({
          LayoutAuthCompetitionsLicenseIdDataRoute,
          LayoutAuthCompetitionsLicenseIdInfoRoute,
          LayoutAuthCompetitionsLicenseIdScoreRoute,
          LayoutAuthCompetitionsLicenseIdSubmissionRoute,
        }),
      LayoutAuthProfileUserIdRoute,
      LayoutAuthProfileChangePasswordRoute,
      LayoutAuthCompetitionsIndexRoute,
      LayoutAuthProfileIndexRoute,
    }),
    LayoutForgetPasswordRoute,
    LayoutSetPasswordRoute,
    LayoutSigninEmailLazyRoute,
    LayoutSignoutLazyRoute,
  }),
  AuthCallbackRoute,
  SigninRoute,
  AboutLazyRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_layout",
        "/auth-callback",
        "/signin",
        "/about"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/_auth",
        "/_layout/forget-password",
        "/_layout/set-password",
        "/_layout/signin-email",
        "/_layout/signout"
      ]
    },
    "/auth-callback": {
      "filePath": "auth-callback.tsx"
    },
    "/signin": {
      "filePath": "signin.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/_layout/_auth": {
      "filePath": "_layout/_auth.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/_auth/competitions/$licenseId",
        "/_layout/_auth/profile/$userId",
        "/_layout/_auth/profile/change-password",
        "/_layout/_auth/competitions/",
        "/_layout/_auth/profile/"
      ]
    },
    "/_layout/forget-password": {
      "filePath": "_layout/forget-password.tsx",
      "parent": "/_layout"
    },
    "/_layout/set-password": {
      "filePath": "_layout/set-password.tsx",
      "parent": "/_layout"
    },
    "/_layout/signin-email": {
      "filePath": "_layout/signin-email.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/signout": {
      "filePath": "_layout/signout.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/_auth/competitions/$licenseId": {
      "filePath": "_layout/_auth/competitions/$licenseId.tsx",
      "parent": "/_layout/_auth",
      "children": [
        "/_layout/_auth/competitions/$licenseId/data",
        "/_layout/_auth/competitions/$licenseId/info",
        "/_layout/_auth/competitions/$licenseId/score",
        "/_layout/_auth/competitions/$licenseId/submission"
      ]
    },
    "/_layout/_auth/profile/$userId": {
      "filePath": "_layout/_auth/profile/$userId.tsx",
      "parent": "/_layout/_auth"
    },
    "/_layout/_auth/profile/change-password": {
      "filePath": "_layout/_auth/profile/change-password.tsx",
      "parent": "/_layout/_auth"
    },
    "/_layout/_auth/competitions/": {
      "filePath": "_layout/_auth/competitions/index.tsx",
      "parent": "/_layout/_auth"
    },
    "/_layout/_auth/profile/": {
      "filePath": "_layout/_auth/profile/index.tsx",
      "parent": "/_layout/_auth"
    },
    "/_layout/_auth/competitions/$licenseId/data": {
      "filePath": "_layout/_auth/competitions/$licenseId/data.tsx",
      "parent": "/_layout/_auth/competitions/$licenseId"
    },
    "/_layout/_auth/competitions/$licenseId/info": {
      "filePath": "_layout/_auth/competitions/$licenseId/info.tsx",
      "parent": "/_layout/_auth/competitions/$licenseId"
    },
    "/_layout/_auth/competitions/$licenseId/score": {
      "filePath": "_layout/_auth/competitions/$licenseId/score.tsx",
      "parent": "/_layout/_auth/competitions/$licenseId"
    },
    "/_layout/_auth/competitions/$licenseId/submission": {
      "filePath": "_layout/_auth/competitions/$licenseId/submission.tsx",
      "parent": "/_layout/_auth/competitions/$licenseId"
    }
  }
}
ROUTE_MANIFEST_END */
